import * as messagingTypes from './messagingTypes';
import cloneDeep from 'lodash.clonedeep';
import { MESSAGEBOX_TYPES, MESSAGEDETAIL_TYPES, MESSAGEORDER_TYPES, MESSAGEBOX_VIEWS } from 'src/constants/constants';

const initialState = {
  inbox: {
    meta: {
      pageNum: 0,
      messagesPerPage: 0,
      selectedIndex: 0,
    },
    filters: {
      engagement: null,
      priority: null,
      sortDirection: MESSAGEORDER_TYPES.DESC,
      dateFrom: null,
      dateTo: null,
      searchText: '',
    },
    messages: [],
  },
  draft: {
    meta: {
      pageNum: 0,
      messagesPerPage: 0,
      selectedIndex: 0,
    },
    filters: {
      engagement: null,
      priority: null,
      sortDirection: MESSAGEORDER_TYPES.DESC,
      dateFrom: null,
      dateTo: null,
      searchText: '',
    },
    messages: [],
  },
  sent: {
    meta: {
      pageNum: 0,
      messagesPerPage: 0,
      selectedIndex: 0,
    },
    filters: {
      engagement: null,
      priority: null,
      sortDirection: MESSAGEORDER_TYPES.DESC,
      dateFrom: null,
      dateTo: null,
      searchText: '',
    },
    messages: [],
  },
  countInbox: 0,
  countInboxUnread: 0,
  countSent: 0,
  countDrafts: 0,
  selectedMenu: MESSAGEBOX_TYPES.INBOX,
  anchorModal: null,
  showFilterModal: false,
  showToastMessage: false,
  toastMessage: '',
  detailType: MESSAGEDETAIL_TYPES.VIEWMESSAGE,
  messageShown: {},
  currentView: MESSAGEBOX_VIEWS.LIST,
  engagements: [],
  composeDrawerState: {
    open: false,
  },
  composeToAddress: null,
  caseId: null,
  composeId: null,
  attachments: [],
  casesMessages: null,
};

const messagingReducer = (state = initialState, action) => {
  const selectedMenuState = state[state.selectedMenu];
  switch (action.type) {
    case messagingTypes.GET_MESSAGES_SUCCESS:
      let messages = cloneDeep(state[action.menu].messages);

      if (action.insertFront) {
        messages.unshift(...action.data.messages);
      } else {
        messages.push(...action.data.messages);
      }
      return {
        ...state,
        [action.menu]: { ...state[action.menu], messages: messages },
      };
    case messagingTypes.GET_MESSAGE_DETAILS_SUCCESS: {
      const { [state.selectedMenu]: messageType } = state;
      return {
        ...state,
        messageShown: action.data,
        [state.selectedMenu]: {
          ...messageType,
          meta: { ...messageType.meta, selectedIndex: action.data.id },
        },
      };
    }
    case messagingTypes.SELECT_MENU:
      return { ...state, selectedMenu: action.data };
    case messagingTypes.SELECT_MESSAGE:
      const { [state.selectedMenu]: messageType } = state;
      return {
        ...state,
        [state.selectedMenu]: {
          ...messageType,
          meta: { ...messageType.meta, selectedIndex: action.id },
        },
      };
    case messagingTypes.SELECT_DETAIL_VIEW:
      return { ...state, detailType: action.data };
    case messagingTypes.GET_COUNTS_SUCCESS:
      return {
        ...state,
        countInbox: action.data.countInbox,
        countSent: action.data.countSent,
        countDrafts: action.data.countDrafts,
        countInboxUnread: action.data.countUnread,
      };
    case messagingTypes.APPLY_FILTERS_PENDING:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          messages: [],
          filters: { ...selectedMenuState.filters, ...action.payload },
        },
      };
    case messagingTypes.CLEAR_FILTERS_PENDING:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          filters: {
            engagement: null,
            priority: null,
            sortDirection: MESSAGEORDER_TYPES.DESC,
            dateFrom: null,
            dateTo: null,
          },
        },
      };
    case messagingTypes.SHOW_FILTER_MODAL:
      return {
        ...state,
        showFilterModal: action.status,
        anchorModal: action.anchorEl, // I leave this for future fix of the popover modal location
      };
    case messagingTypes.CHANGE_SORT_ORDER:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          messages: [],
          filters: {
            ...selectedMenuState.filters,
            sortDirection: action.sortDirection,
          },
        },
      };
    case messagingTypes.SENDMESSAGE_PENDING:
      return { ...state };
    case messagingTypes.SHOW_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: true, toastMessage: action.data };
    case messagingTypes.HIDE_NOTIFICATION_SUCCESS:
      return { ...state, showToastMessage: false };
    case messagingTypes.SWITCH_VIEW:
      return { ...state, currentView: action.view };
    case messagingTypes.ENGAGEMENT_LOAD_SUCCESS:
      return { ...state, engagements: action.engagements };
    case messagingTypes.TOGGLE_COMPOSE_DRAWER:
      return { ...state, composeDrawerState: action.payload };
    case messagingTypes.SET_ATTACHMENTS: {
      const attachments = state.attachments.slice();
      attachments.push({ messageId: action.composeId, attachmentId: action.attachmentId });
      return { ...state, composeId: action.composeId, attachments };
    }
    // case messagingTypes.GET_CASES_MESSAGES_SUCCESS:
    //   return { ...state, casesMessages: action.messages };
    case messagingTypes.RESET_MESSAGE_SHOWN:
      return { ...state, messageShown: {} };
    case messagingTypes.RESET_ATTACHMENTS:
      return { ...state, composeId: null, attachments: [] };
    case messagingTypes.DELETE_ATTACHMENT: {
      const attachments = state.attachments.slice();
      attachments.splice(action.index, 1);
      return { ...state, attachments };
    }

    case messagingTypes.RESUME_DRAFT_MESSAGE:
      const caseId = action.caseId || null;

      return { ...state, composeToAddress: action.accountInfo, caseId };
    case messagingTypes.CLEAR_RESUME_DRAFT:
      return { ...state, composeToAddress: null };

    case messagingTypes.RESET_COMPOSE_ID:
      return { ...state, composeId: null };
    case messagingTypes.SET_COMPOSE_ID:
      return { ...state, composeId: action.data };
    case messagingTypes.RESET_SEARCH_TEXT:
      return {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          messages: [],
          filters: {
            ...selectedMenuState.filters,
            searchText: '',
          },
        },
      };
    case messagingTypes.SET_SEARCH_TEXT:
      let newState = {
        ...state,
        [state.selectedMenu]: {
          ...selectedMenuState,
          messages: [],
          filters: {
            ...selectedMenuState.filters,
            searchText: action.data,
            filter: true,
          },
        },
      };
      return newState;
    default:
      return state;
  }
};

export { initialState };
export default messagingReducer;
